"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.active.help': 'Gli avatar inattivi non sono visibili agli utenti normali',
};
